<div class="container-fluid blotter_top_interaction_bar" #topMenu>
  <div class="blotter_titlebar_interaction">
    <div class="blotter_filter_bar blotter_filter_bar_container">
      <bfx-blotter-ops-int-blotter-filter-bar
        class="bfx-blotter-ops-int-filter-bar blotter_filter_bar"
        [blotterInstance]="parent.blotterInstance"
      ></bfx-blotter-ops-int-blotter-filter-bar>
    </div>
    <div class="bfx-blotter-tools-container">
      <bfx-quick-search
        class="bfx-quick-search"
        [(ngModel)]="parent.searchValue"
        (ngModelChange)="parent.onChangeSearchValue()"
      ></bfx-quick-search>
      <div class="blotter_titlebar_interaction_right">
        <bfx-icon-button
          size="sm"
          [disabled]="parent?.newAlert !== true"
          iconClass="icon_ion_visibility_filled"
          (action)="parent?.markAllAsSeen()"
          title="Mark all as seen and clear alert"
        ></bfx-icon-button>

        <!-- OMS-33145 has a fixed set of categories, hide filter-manager toggle
				<label
					(click)="parent.showFilterManager($event)"
					class="btn btn-default blotter_interaction_buttons icon icon_ion_filter_filled"
					title="Filter Manager"
				></label>
				-->
      </div>
    </div>
  </div>
</div>
